import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import {Row, Col, Card} from 'reactstrap'
import MainManual from '../../components/Manual/MainManual'

export default class Manual extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="12">
            <Card>
              <Switch>
                <Route exact path="/manual" component={MainManual}/>
              </Switch>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Manual/Manual.js